/**
 * Language-related constants
 */

// All available languages (including hidden ones)
export const ALL_LANGUAGE_OPTIONS = [
  { code: "en", name: "English" },
  { code: "am", name: "አማርኛ" }, // Amharic
  { code: "om", name: "Afaan Oromoo" }, // Afan Oromo
  { code: "ti", name: "ትግርኛ" }, // Tigrigna
] as const;

// Languages visible in UI (excluding om and ti)
export const LANGUAGE_OPTIONS = ALL_LANGUAGE_OPTIONS.filter(
  lang => !['om', 'ti'].includes(lang.code)
);

export const SUPPORTED_LANGUAGES = ["en", "am", "om", "ti"] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];
